import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProjectsTableComponent } from '../projects-table/projects-table.component';
import { SubProject } from 'src/app/model/project/sub-project';
import { Adjustment } from 'src/app/model/project/adjustment';

@Component({
  selector: 'finishing-projects',
  templateUrl: '../projects-table/projects-table.component.html',
  styleUrls: ['../projects-table/projects-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FinishingProjectsComponent extends ProjectsTableComponent {
  ngOnInit() {
    super.ngOnInit();
    this.projects = [];
    this.displayedColumns = [
      'project_id',
      'currentFinishDate',
      'currentConfirmedPlacementDate',
      'company',
      'projectPlacement.address',
      'productType',
      'productSize',
      'finisher',
      'displayStatus',
      'star',
    ];
  }

  protected getLocalStorageKey(): string {
    return 'FinishingProjectsComponent';
  }

  protected getStatusFilter(): string {
    return 'statusSubstatus/vv,Afhaling,Aanpassing,Concept,Nieuw,In_behandeling/Afwerking';
  }

  public getPageTitle(): string {
    return 'Afwerking';
  }

  // Override
  public getDefaultSort(): string {
    return 'currentFinishDate';
  }

  // Override
  protected preProcessProjects(projects: SubProject[]): void {
    if (projects == null) {
      return;
    }

    super.preProcessProjects(projects);
    projects.forEach((p) => {
      p.applyGreenBackground =
        p.type === 'BaseProject'
          ? this.applyGreenBackgroundBaseProject(p)
          : this.applyGreenBackgroundAdjustment(p);
    });
  }

  private applyGreenBackgroundBaseProject(subProject: SubProject) {
    return (
      subProject.project != null &&
      subProject.project.products != null &&
      subProject.project.products.some((p) => p != null && p.needPrintwork) &&
      subProject.project.products.every(
        (p) => p == null || !p.needPrintwork || p.printWorkReady
      )
    );
  }

  private applyGreenBackgroundAdjustment(subProject: SubProject): boolean {
    return (<Adjustment>subProject).printWorkReady;
  }
}
